import service from "@/store/services/properties-payments-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  propertiesPayment: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, propertiesPayment) => {
    state.propertiesPayment = propertiesPayment;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((propertiesPayment) => {
      commit("SET_RESOURCE", propertiesPayment);
    });
  },

  print({ commit, dispatch }, params) {
    return service.print(params, this.$axios);
  },

  printOne({ commit, dispatch }, params) {
    return service.print(params, this.$axios);
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((propertiesPayment) => {
      commit("SET_RESOURCE", propertiesPayment);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((propertiesPayment) => {
      commit("SET_RESOURCE", propertiesPayment);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  sendMailReceipt({ commit, dispatch }, params) {
    return service.sendMailReceipt(params, this.$axios).then((propertiesPayment) => {
      commit("SET_RESOURCE", propertiesPayment);
    });
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  propertiesPayment: (state) => state.propertiesPayment
};

const propertiesPayments = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default propertiesPayments;
